var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGolf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_460)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6876 7.74038L19.7796 8.68167L23.5312 0.46875H21.0092L17.6876 7.74038Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4739 7.64421L14.8003 13.4971C14.0929 15.0457 12.5469 16.0391 10.8444 16.0391H12.1873H13.8817C15.5843 16.0391 17.1302 15.0457 17.8377 13.4971L19.9934 8.77784L17.4739 7.64421Z",
    fill: "#A0B4C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2021 12.737C17.2021 14.5607 15.7236 16.0391 13.9 16.0391H6.69264C4.35709 16.0391 2.63031 13.864 3.16005 11.5893L3.67127 9.39408C4.18347 7.19475 6.55924 5.99302 8.63439 6.88365L15.2023 9.70252C16.4156 10.2232 17.2021 11.4166 17.2021 12.737Z",
    fill: "#27AAE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5252 19.1658C8.31781 19.1658 10.5817 16.902 10.5817 14.1094C10.5817 11.3168 8.31781 9.05291 5.5252 9.05291C2.7326 9.05291 0.46875 11.3168 0.46875 14.1094C0.46875 16.902 2.7326 19.1658 5.5252 19.1658Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.64879 19.1658C3.45766 20.0995 3.99893 21.2348 4.21516 22.4511L4.40721 23.5313H6.64324L6.83529 22.4511C7.05152 21.2348 7.59279 20.0995 8.40166 19.1658H2.64879Z",
    fill: "#27AAE1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5829 0.273987C20.6591 0.107075 20.8257 0 21.0092 0H23.5312C23.6907 0 23.8393 0.0811329 23.9255 0.21534C24.0118 0.349547 24.0238 0.518402 23.9576 0.663509L22.9584 2.85098C22.8508 3.08646 22.5727 3.19016 22.3372 3.08259C22.1018 2.97503 21.9981 2.69694 22.1056 2.46146L22.8017 0.9375H21.3104L18.3099 7.50634L19.5469 8.06295L20.3525 6.29945C20.46 6.06396 20.7381 5.96027 20.9736 6.06783C21.2091 6.17539 21.3128 6.45348 21.2052 6.68896L20.206 8.87643C20.0989 9.11097 19.8224 9.21495 19.5873 9.10914L17.4953 8.16785C17.3815 8.11665 17.2928 8.02219 17.2489 7.9054C17.2049 7.7886 17.2094 7.65911 17.2612 7.54561L20.5829 0.273987Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0477 7.44938C17.1548 7.21485 17.4312 7.11088 17.6664 7.21668L20.1859 8.3503C20.2997 8.4015 20.3883 8.49596 20.4323 8.61275C20.4762 8.72955 20.4717 8.85904 20.4199 8.97254L18.2642 13.6918L18.2642 13.6918C17.4805 15.4073 15.7679 16.5078 13.8818 16.5078C13.6229 16.5078 13.4131 16.298 13.4131 16.0391C13.4131 15.7802 13.6229 15.5703 13.8818 15.5703C15.4009 15.5703 16.7802 14.6839 17.4114 13.3022C17.4114 13.3022 17.4114 13.3022 17.4114 13.3022L19.3713 9.01181L17.7067 8.26287L16.6653 10.5428C16.5577 10.7782 16.2796 10.8819 16.0442 10.7744C15.8087 10.6668 15.705 10.3887 15.8126 10.1532L17.0477 7.44938Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.44956 7.31438C6.64259 6.53885 4.57385 7.58528 4.12784 9.50038C4.06912 9.75252 3.81712 9.90931 3.56499 9.85059C3.31285 9.79187 3.15606 9.53987 3.21478 9.28774C3.79317 6.80419 6.47596 5.44714 8.81931 6.45287L8.63443 6.88362L8.81931 6.45287L15.3872 9.27175C16.7727 9.8664 17.6709 11.2292 17.6709 12.737C17.6709 14.8195 15.9826 16.5079 13.9 16.5079H10.2679C10.009 16.5079 9.79918 16.298 9.79918 16.0391C9.79918 15.7802 10.009 15.5704 10.2679 15.5704H13.9C15.4648 15.5704 16.7334 14.3018 16.7334 12.737C16.7334 11.604 16.0585 10.5801 15.0175 10.1333L15.1967 9.71557L15.0174 10.1333L8.44956 7.31438Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.37537 9.41037C7.47747 9.17247 7.7531 9.06238 7.99099 9.16449L14.0401 11.7607C14.278 11.8628 14.3881 12.1384 14.286 12.3763C14.1839 12.6142 13.9083 12.7243 13.6704 12.6222L7.62125 10.026C7.38335 9.92389 7.27326 9.64826 7.37537 9.41037Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0348 12.7796C10.1369 12.5417 10.4126 12.4316 10.6504 12.5337L12.4841 13.3207C12.722 13.4228 12.8321 13.6984 12.73 13.9363C12.6279 14.1742 12.3523 14.2843 12.1144 14.1822L10.2807 13.3952C10.0428 13.2931 9.93272 13.0175 10.0348 12.7796Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5252 9.52166C2.99148 9.52166 0.9375 11.5756 0.9375 14.1094C0.9375 16.6431 2.99148 18.6971 5.5252 18.6971C8.05892 18.6971 10.1129 16.6431 10.1129 14.1094C10.1129 11.5756 8.05892 9.52166 5.5252 9.52166ZM0 14.1094C0 11.0579 2.47372 8.58416 5.5252 8.58416C8.57669 8.58416 11.0504 11.0579 11.0504 14.1094C11.0504 17.1608 8.57669 19.6346 5.5252 19.6346C2.47372 19.6346 0 17.1608 0 14.1094Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.22242 18.971C2.29866 18.8041 2.46529 18.697 2.6488 18.697H8.40167C8.58517 18.697 8.7518 18.8041 8.82804 18.971C8.90429 19.1379 8.87612 19.334 8.75598 19.4727C8.00246 20.3426 7.49824 21.4001 7.29681 22.5332L7.29681 22.5332L7.10476 23.6133C7.06498 23.837 6.87048 24 6.64325 24H4.40722C4.17999 24 3.98548 23.837 3.94571 23.6133L3.75366 22.5332L3.75366 22.5332C3.55222 21.4001 3.04801 20.3426 2.29449 19.4727C2.17434 19.334 2.14618 19.1379 2.22242 18.971ZM3.58953 19.6345C4.13151 20.4602 4.50264 21.39 4.67668 22.3691C4.67668 22.3691 4.67668 22.3691 4.67668 22.3691L4.79998 23.0625H6.25049L6.37378 22.3691C6.37378 22.3691 6.37378 22.3691 6.37378 22.3691C6.54783 21.39 6.91896 20.4602 7.46094 19.6345H3.58953Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_460"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGolf);
export default __webpack_public_path__ + "static/media/Golf.b0c2ae7412e282c5f49b02e6ca78b2b9.svg";
export { ForwardRef as ReactComponent };